import { render, staticRenderFns } from "./StatisticExpensesTrend.vue?vue&type=template&id=7d277080"
import script from "./StatisticExpensesTrend.vue?vue&type=script&lang=js"
export * from "./StatisticExpensesTrend.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports